// extracted by mini-css-extract-plugin
export default {"sun":"sun_sun__nA5rY"};